export enum CompanyDetailsFormControls {
	parentCompany = 'parentCompany',
	ownershipType = 'ownershipType',
	doingBusinessAs = 'doingBusinessAs',
	yearBusinessEstablished = 'yearBusinessEstablished',
	principalName = 'principalName',
	stateProvince = 'stateProvince',
	companyWebsiteAddress = 'companyWebsiteAddress',
	dunsNumber = 'dunsNumber',
	federalTaxId = 'federalTaxId',
	naicsCode = 'naicsCode',
	companyPartyToAnyClaimOrLawsuit = 'companyPartyToAnyClaimOrLawsuit',
	taxLinesAgainstCompany = 'taxLinesAgainstCompany',
	companyFiledBankruptcy = 'companyFiledBankruptcy',
	dateFilingBankruptcy = 'dateFilingBankruptcy',
	bankruptcyType = 'bankruptcyType'
}
